import { useAuth } from '../contexts/AuthContext';

// Hook to check user permissions
export const usePermissions = () => {
  const { user } = useAuth();
  
  // Get permissions from user object (loaded from backend)
  const userPermissions = user?.permissions || {};

  return {
    // Organigramme permissions
    canModifyOrgchartLayout: userPermissions.orgchart_modify_layout || false,
    
    // Mailing lists permissions  
    canCreatePredefinedLists: userPermissions.mailing_create_predefined || false,
    
    // Helper to check any permission
    hasPermission: (permissionId) => {
      return userPermissions[permissionId] || false;
    },
    
    // All user permissions
    userPermissions
  };
};